import "./globals.css";
import type { QueryClient } from "@tanstack/react-query";
import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";
import { ProviderCollection } from "$/modules/shared/provider/provider-collection";
import { ErrorFallback } from "$/modules/shared/ui/error-fallback";

export const Route = createRootRouteWithContext<{ queryClient: QueryClient }>()(
	{
		component: RootLayout,
		errorComponent: ({ error, reset }) => (
			<ErrorFallback error={error} reset={reset} />
		),
		notFoundComponent: () => <ErrorFallback variant="notFound" />,
	},
);

function RootLayout() {
	return (
		<ProviderCollection>
			<Outlet />
		</ProviderCollection>
	);
}
